import type { ActivityOverviewSupportDto } from '../../../../core/api/FitnessActivityClient';

export function parseOffsetMinutes(isoString: string): number {
    const match = isoString.match(/([+-])(\d{2}):(\d{2})$/);
    if (!match) return 0;
    const sign = match[1] === '+' ? 1 : -1;
    return sign * (parseInt(match[2], 10) * 60 + parseInt(match[3], 10));
}

export function resolveUserOffsetMinutes(
    data: ActivityOverviewSupportDto
): number {
    const firstFrom = data.dailySteps
        .flatMap((s) => s.chunks)
        .find((c) => c.timeRange?.from)?.timeRange.from;
    return firstFrom ? parseOffsetMinutes(firstFrom) : 0;
}

export function formatUtcOffsetLabel(offsetMinutes: number): string {
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const absMinutes = Math.abs(offsetMinutes);
    const hours = Math.floor(absMinutes / 60);
    const minutes = absMinutes % 60;
    return minutes === 0
        ? `UTC${sign}${hours}`
        : `UTC${sign}${hours}:${String(minutes).padStart(2, '0')}`;
}
